export default "__VITE_ASSET__DfdxAdko__"